import {
  takeLatest,
  put,
  select,
  take,
  cancel,
  race,
  call,
} from 'redux-saga/effects';

import { hideLoaderInPopup, showLoaderInPopup } from '../../ui/popup';
import * as myProviders from '../requests/my-providers-req';
import { redirectToVisitType } from '../../../utils/appointments/redirect-utils';
import { selectProgressCareUserId } from '../selectors';
import * as error from '../../ui/error';

function* fetchMyProviders({ payload: data }) {
  const userId = yield select(selectProgressCareUserId);
  yield put(showLoaderInPopup());
  yield put(
    myProviders.actions.send({
      userId,
      organizationId: data.id,
      limit: 3,
      offset: 0,
    }),
  );
  const { success } = yield race({
    error: take([
      myProviders.consts.REJECTED,
      myProviders.consts.ERROR_ENCOUNTERED,
    ]),
    success: take(myProviders.consts.SUCCEED),
  });

  yield put(hideLoaderInPopup());

  if (success) {
    yield call(redirectToVisitType);
  } else {
    yield put({
      type: error.consts.UPDATE,
      payload: { id: 'errors.common' },
    });
    yield cancel();
  }
}

export default function* myProvidersListGuard() {
  yield takeLatest(myProviders.consts.INIT, fetchMyProviders);
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/my-providers-list-guard-saga.js